import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { UserContext } from "../../App";
import Dashboard from "../../Pages/User/Dashboard";
import VehicleStatus from "../../Pages/User/VehicleStatus";
import OfflineAnalysis from "../../Pages/User/OfflineAnalysis";
import HighRiskActivity from "../../Pages/User/HighRiskActivity";
import AddHighRiskActivity from "../../Pages/User/AddHighRiskActivity";
import ViewHighRiskActivityDetail from "../../Pages/User/ViewHighRiskActivityDetail";
import SuspectedTheft from "../../Pages/User/SuspectedTheft";
import AddAutomatedShutdown from "../../Pages/User/AddAutomatedShutDown";
import ProbabilityMeter from "../../Pages/User/ProbabilityMeter";
import CallLogs from "../../Pages/User/CallLogs";
import Geofences from "../../Pages/User/Geofences";
import AddGeofences from "../../Pages/User/AddGeofences";
import ViewGeofences from "../../Pages/User/ViewGeofences";
import CustomerList from "../../Pages/User/CustomerList";
import AddCustomerList from "../../Pages/User/AddCustomerList";
import ViewCustomerDetails from "../../Pages/User/ViewCustomerDetails";
import Notifications from "../../Pages/User/Notifications";
import Settings from "../../Pages/User/Settings";
import VehicleInformation from "../../Pages/User/VehicleInformation";
import Shutdown from "../../Pages/User/Shutdown";
import ViewNotificationDetails from "../../Pages/User/ViewNotificationDetails";

const permissionPages = {
  monitoring: [
    { key: "dashboard", path: "/dashboard", component: Dashboard },
    {
      key: "vehicle_status",
      path: "/vehicle-status",
      component: VehicleStatus,
    },
    {
      key: "offline_analysis",
      path: "/offline-analysis",
      component: OfflineAnalysis,
    },
  ],
  security: [
    { key: "high_risk", path: "/high-risk", component: HighRiskActivity },
    {
      key: "high_risk_add",
      path: "/add-high-risk",
      component: AddHighRiskActivity,
    },
    {
      key: "high_risk_view",
      path: "/view-high-risk-detail/:id",
      component: ViewHighRiskActivityDetail,
    },
    {
      key: "notification_detail_view",
      path: "/view-notification-detail/:id",
      component: ViewNotificationDetails,
    },
    { key: "theft", path: "/theft", component: SuspectedTheft },
    { key: "shutdown", path: "/shut-down", component: Shutdown },
    {
      key: "shutdown_add",
      path: "/add-shutdown",
      component: AddAutomatedShutdown,
    },
    { key: "probability", path: "/probability", component: ProbabilityMeter },
    { key: "calls", path: "/calls", component: CallLogs },
  ],
  geoenforcing: [
    { key: "geofences", path: "/geofences", component: Geofences },
    { key: "geofences_add", path: "/add-geofences", component: AddGeofences },
    {
      key: "geofences_view",
      path: "/view-geofences",
      component: ViewGeofences,
    },
  ],
  customer: [
    { key: "customer_list", path: "/customer-list", component: CustomerList },
    {
      key: "customer_add",
      path: "/add-customer-list",
      component: AddCustomerList,
    },
    {
      key: "customer_view",
      path: "/view-customer-details/:id",
      component: ViewCustomerDetails,
    },
    {
      key: "add_vehicle",
      path: "/add-vehicles",
      component: VehicleInformation,
    },
  ],
};

const UserRoutes = () => {
  const { userData } = useContext(UserContext);
  const userPermissions = userData?.permissions || [];

  const allowedPages = userPermissions.flatMap(
    (perm) => permissionPages[perm] || [],
  );

  const firstPage = allowedPages[0]?.path || "/settings";

  return (
    <Routes>
      {allowedPages.map((page) => (
        <Route key={page.key} path={page.path} element={<page.component />} />
      ))}
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/settings" element={<Settings />} />

      <Route path="*" element={<Navigate to={firstPage} replace />} />
    </Routes>
  );
};

export default UserRoutes;
